<template lang="html">
  <div class="main-containter">
    <!-- <Header class="header">
      <div class="header-left">
        <router-link :to="{ name: 'Main' }">
          <img src="~mpic/logo.png">
        </router-link>
      </div>
      <div class="header-right" @click="is_show_menu = true">
        <i class="iconfont">&#xe70e;</i>
      </div>
    </Header>
    <div class="right-menu" :class="{'show': is_show_menu}">
      <div class="login-div">
        <div class="login-button" v-if="!user_key">
          <router-link :to="{ name: 'Login'}">登录</router-link>
        </div>
        <div class="logined" v-else>
          <div>
            <img :src="user.head_path | img_url_finish" v-if="user.head_path">
            <img :src="$store.state.static_img_url+'/img/default-head-img.png'" v-else>
            <span>{{user.name}}</span>
          </div>
          <div>
            <router-link to="/user" class="href"><span>个人中心</span><i class="iconfont">&#xe705;</i></router-link>
          </div>
        </div>
      </div>
      <div class="li-list">
        <div :class="{'active': tab_active == 0}" @click="goTab(0)"><span>首页</span></div>
        <div :class="{'active': tab_active == 1}" @click="goTab(1)"><span>论坛</span></div>
        <div :class="{'active': tab_active == 2}" @click="goTab(2)"><span>学习班</span></div>
        <div :class="{'active': tab_active == 3}" @click="goTab(3)"><span>团队</span></div>
        <div :class="{'active': tab_active == 4}" @click="goTab(4)"><span>活动</span></div>
        <div :class="{'active': tab_active == 5}" @click="goTab(5)"><span>患者</span></div>
        <div :class="{'active': tab_active == 6}" @click="goTab(6)"><span>合作伙伴</span></div>
        <div class="out" v-if="user_key" @click="closeLogin"><span>退出</span></div>
      </div>
      <img class="footer-logo" src="~mpic/menu-footer.png">
    </div>
    <div class="mask" v-if="is_show_menu" @click="is_show_menu = false"></div> -->
    <PrivateHeader></PrivateHeader>
    <Content>
      <swiper ref="main-swiper" :options="swiper_option" :style="{'height': height+'px'}">
        <!-- <swiper-slide class="slide1">
          <img src="~mpic/main1-1.png">
          <img src="~mpic/main1-2.png">
          <Button :to="{name: 'Forum'}" class="custom-button">立即查看</Button>
          <div class="imgs">
            <a target="_blank" v-for="item in banners" :key="item.id" :href="item.url"><img :src="item.mobile_banner_path | img_url_finish"></a>
          </div>
          <img src="~mpic/main1-4.png">
        </swiper-slide> -->
        <swiper-slide class="slide2">
          <div>
            <div @click="goPlay('media1')">
              <video ref="media1" :src="$store.state.static_img_url+'/video/index_forum.mp4'"  :controls="media1_isplay" poster="~pic/main2-2.png"></video>
              <i class="iconfont" v-if="!media1_isplay">&#xe70d;</i>
            </div>
            <div>
              <p>盘古大血管疾病论坛介绍</p>
              <p>{{detail.forum_desc}}</p>
            </div>
          </div>
          <div>
            <Button :to="{name: 'ForumHistory'}" class="custom-button">了解更多</Button>
          </div>
        </swiper-slide>
        <swiper-slide class="slide3">
          <div>
            <div @click="goPlay('media2')">
              <video ref="media2" :src="$store.state.static_img_url+'/video/class.mp4'"  :controls="media2_isplay" poster="~pic/main3-2.png"></video>
              <i class="iconfont" v-if="!media2_isplay">&#xe70d;</i>
            </div>
            <div>
              <p>主动脉外科学习班介绍</p>
              <p>{{detail.class_desc}}</p>
            </div>
          </div>
          <div>
            <Button :to="{name: 'StudyClass'}" class="custom-button">了解更多</Button>
          </div>
        </swiper-slide>
        <swiper-slide class="slide4">
          <div>
            <swiper class="slide4-swiper" :options="slide4_swiper_option" ref="slide4-swiper" v-if="slide4_peo_arr.length">
              <swiper-slide v-for="(item, index) in slide4_peo_arr" :key="Math.random()">
                <router-link :to="{ name: 'TeamDetail', params: {id: item.guest_id} }">
                  <img :src="item.banner_path | img_url_finish">
                </router-link>
              </swiper-slide>
              <!-- <div class="swiper-pagination" slot="pagination"></div> -->
            </swiper>
            <p class="transform-in-out">团队介绍</p>
            <p class="transform-in-out">{{detail.group_desc}}</p>
          </div>
          <div>
            <Button :to="{name: 'Team'}" class="custom-button">团队详情</Button>
          </div>
        </swiper-slide>
        <swiper-slide class="slide5">
          <div>
            <a href="#">
              <img src="~mpic/apply-banner.png">
            </a>
            <p>第九届盘古大血管疾病论坛—报名通道</p>
            <p>为确保大会的学术质量和与会代表的互动交流，第九届盘古大会组委会热情欢迎广大心脏大血管疾病临床医生和其他心血管相关工作者踊跃投稿，报告研究成果和新进展，参与学术交流。
            </p>
            <div class="grid">
              <div v-for="item,index in activity" :key="item.id" v-if="index<4">
                <router-link :to="{name: 'ActivityDetail',params:{ id: item.id }}">
                  <img :src="item.logo_path | img_url_finish">
                </router-link>
                <div>
                  <p>{{item.title}}</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <Button :to="{name: 'Activity'}" class="custom-button">查看全部</Button>
          </div>
        </swiper-slide>
        <swiper-slide class="slide6">
          <div class="content" :class="{'show': slide6_tab == '1', 'hide': slide6_tab != '1'}">
            <p>医疗咨询“孙立忠大血管团队”</p>
            <p>如果您想联系由孙立忠主任领衔的孙立忠大血管团队，或者您曾经是经过该团救治过的病人患者，如果您希望术后可以随时得到专家团队的康复指导和建议。您可以使用手机微信扫描二维码，关注“孙立忠心脏大血管团队”微信服务号，找到右下角“联系医生”栏目下的“医生服务”与医生建立线上链接。</p>
            <img src="~pic/main6-1.png">
          </div>
          <div class="content" :class="{'show': slide6_tab == '2', 'hide': slide6_tab != '2'}">
            <p>发现名医“大医生兵器谱”</p>
            <p>垂直专业的医疗媒体品牌。聚焦国内医疗顶尖团队，原创报道顶尖医生传记和深度科普专题为主要内容。从2014年6月首发以来，“大医生兵器谱”跨平台发表过近200位国内顶尖医生的人物传记，拥有肖像图片2500+。报道内容在业内颇受赞誉，且获得卫计委的认可和转载。</p>
            <img src="~pic/main6-1.png">
          </div>
          <div class="content" :class="{'show': slide6_tab == '3', 'hide': slide6_tab != '3'}">
            <p>康心马凡</p>
            <p>康心马凡综合征关爱中心成立于2015年3月，由马凡综合征、大血管病等患者发起。致力于为马凡综合征开展救助关怀、社会融入等工作，促进社会和公众对马凡综合征的了解和尊重，消除社会对他们的歧视，维护该群体在医疗、教育、防控、就业、救助、关怀等方面的平等权益，推动有利于马凡综合征群体的社会的保障的相关政策出台。</p>
            <img src="~pic/main6-1.png">
          </div>
          <div class="footer">
            <div :class="{'active': slide6_tab == '1'}" @click="slide6_tab = '1'">
              <img src="~pic/main6-2w.png" v-if="slide6_tab == '1'">
              <img src="~pic/main6-2b.png" v-else>
              <span>医疗咨询</span>
            </div>
            <div :class="{'active': slide6_tab == '2'}" @click="slide6_tab = '2'">
              <img src="~pic/main6-3w.png" v-if="slide6_tab == '2'">
              <img src="~pic/main6-3b.png" v-else>
              <span>发现名医</span>
            </div>
            <div :class="{'active': slide6_tab == '3'}" @click="slide6_tab = '3'">
              <img src="~pic/main6-4w.png" v-if="slide6_tab == '3'">
              <img src="~pic/main6-4b.png" v-else>
              <span>康心马凡</span>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="slide7">
          <div class="slide7-tle">
            合作伙伴
          </div>
          <div class="grid">
            <!-- <div> <img src="~pic/main7-1.png"> </div>
            <div> <img src="~pic/main7-2.png"> </div>
            <div> <img src="~pic/main7-3.png"> </div>
            <div> <img src="~pic/main7-4.png"> </div>
            <div> <img src="~pic/main7-5.png"> </div>
            <div> <img src="~pic/main7-6.png"> </div>
            <div> <img src="~pic/main7-7.png"> </div>
            <div> <img src="~pic/main7-8.png"> </div>
            <div> <img src="~pic/main7-9.png"> </div>
            <div> <img src="~pic/main7-10.png"> </div> -->
            <div v-for="item in partner" :key="item.name">
              <router-link :to="{ name: 'Partner', query: { id: item.org_id }}">
                <img :src="item.logo_path | img_url_finish">
              </router-link>
            </div>
          </div>
          <!-- <div class="footer">
            <p class="title">合作伙伴</p>
            <div class="partner">
              <div class="left">
                <p>安贞医院</p>
                <p>康心马凡</p>
                <p>中国医师协会</p>
                <p>大医生兵器谱</p>
                <p>中国医药生物技术协会心血管外科技术与工程分会</p>
              </div>
              <div class="right">
                <p>北京医学会心血管外科分会</p>
                <p>中华医学会胸心血管外科分会</p>
                <p>北京医师协会心血管外科分会</p>
                <p>北京市大血管疾病诊疗研究中心</p>
                <p>中国医师协会心血管外科医师分会</p>
                <p>中国医药教育协会心脏外科专业委员会</p>
              </div>
            </div>
          </div> -->
          <!-- <Footer></Footer> -->
        </swiper-slide>
        <div class="swiper-pagination main-swiper-pagination" slot="pagination"></div>
      </swiper>
    </Content>
  </div>
</template>

<script>
import PrivateHeader from '../components/Headers/header2'
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Swiper from 'swiper'
import { index, getBanner,logout } from '../service'
import Footer from '../components/footer'
export default {
  data() {
    return {
      banners:'',
      detail: '',
      activity: '',
      group_member: '',
      partner: '',
      loading_show: true,

      is_show_menu: false,
      tab_active: 0,
      swiper_option: {
        direction: 'vertical',
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        mousewheel: true,
        on: {
          slideChange: () => {
            this.tab_active = this.swiper.activeIndex
            this.$refs['media1'].pause()
            this.$refs['media2'].pause()
          }
        }
      },
      slide4_swiper_option: {
        slidesPerView: 5,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop: true,
        autoplay:true,
        observer:true,
        watchSlidesVisibility: true
      },
      slide4_peo_arr: [],
      height: 0,
      media1_isplay: false,
      media2_isplay: false,

      slide6_tab: '1'
    }
  },
  components: {
    swiper,
    swiperSlide,
    Footer,
    PrivateHeader
  },
  computed: {
    swiper() {
      return this.$refs['main-swiper'].swiper
    },
    slide4_swiper() {
      return this.$refs['slide4-swiper'].swiper
    },
    user() {
      return this.$store.state.user
    },
    user_key() {
      return this.$store.state.user_key
    }
  },
  methods: {
    async getBanner() { // 广告
      let res = await getBanner({banner_position_id: 7} ,(error) => { this.$Message.error('请求错误！') })
      if (res.status == 'success') {
        this.banners =  res.banner
      } else {
        this.$Message.error(res.message)
      }
      this.loading_show = false
    },
    async getDetail() { // 获取详情
      let res = await index({} ,(error) => { this.$Message.error('请求错误！') })
      if (res.status == 'success') {
        this.detail = res.index[0]
        this.activity = res.activity
        this.slide4_peo_arr = res.group_member
        this.partner = res.partner
      } else {
        this.$Message.error(res.message)
      }
      this.loading_show = false
    },
    goPlay(s) {
      this[s+'_isplay'] = true
      this.$refs[s].play()
    },
    goTab(index) {
      this.tab_active = index
      this.swiper.slideTo(index)
    },
    async closeLogin() {
      let res = await logout({user_key: this.user_key}, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.$Message.success('退出成功！')
        this.$store.commit('updateUser', '')
        this.$store.commit('updateUserKey', '')
        this.$store.commit('apply_activity', '')

        window.localStorage.removeItem('timestamp_left')
        window.localStorage.removeItem('timestamp_right')
        window.localStorage.removeItem('user')
        window.localStorage.removeItem('user_key')
      } else {
        this.$Message.error(res.message)
      }
    }
  },
  created() {
    this.getDetail()
    this.getBanner()
  },
  mounted() {
    if (window.innerHeight)
    this.height = window.innerHeight-44;
    else if ((document.body) && (document.body.clientHeight))
    this.height = document.body.clientHeight-44;
  }
}
</script>

<style lang="stylus" scoped>
@import '~mstyles/header';
ellipsisClamp2()
  display: -webkit-box
  overflow: hidden
  text-overflow: ellipsis
  word-break: break-all
  -webkit-box-orient: vertical
.main-containter
  >>>.ivu-layout-content
    background: #fff;
    padding-top: 44px;
  >>>.ivu-layout-header
    height: 44px;
  //   padding: 0 .32rem;
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;
  //   background: #fff;
  //   border-bottom: 1px solid #EEEEEE;
  //   z-index: 100;
  //   >a
  //     img
  //       height: .6rem;
  .slide1
    padding: .5rem;
    background-repeat: no-repeat;
    background-image: url('~mpic/main1-3.png');
    background-position: center;
    background-size: 100% auto;
    >img:nth-child(1)
      width: 3.11rem;
      height: 1.2rem;
    >img:nth-child(2)
      width: 100%;
      margin-top: 1.68rem;
    .custom-button
      margin: .58rem auto 0;
      display: block;
    .imgs
      display: flex;
      justify-content: space-between;
      margin-top: .54rem;
      img
        width: 2rem;
        height: 1.6rem;
        border-radius: .1rem;
    >img:nth-child(5)
      width: 100%;
      margin-top: .48rem;
  .slide2
    background-image: url('~mpic/main2-1.png');
  .slide3
    background-image: url('~mpic/main3-1.png');
  .slide2,.slide3
    padding: .6rem .46rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center bottom;
    >div:nth-child(1)
      >div:nth-child(1)
        position: relative;
        video
          width: 100%;
          height: 3rem;
          background: #000;
        i
          font-size: .58rem;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          color: #fff;
      >div:nth-child(2)
        margin-top: .2rem;
        background-repeat: no-repeat;
        background-image: url('~pic/main2-1.png');
        background-size: .76rem 3.38rem;
        background-position: left center;
        p
          text-align: center;
          color: #333;
        p:nth-child(1)
          font-size: .32rem;
          font-weight: bold;
        p:nth-child(2)
          font-size: .26rem;
          line-height: .42rem;
          height: 5.88rem;
          margin-top: .2rem;
          padding: 0 .3rem;
          ellipsisClamp2()
          -webkit-line-clamp: 14
    >div:nth-child(2)
      .custom-button
        margin: 0 auto;
        display: block;
  .slide4
    padding: .6rem 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    >div:nth-child(1)
      .slide4-swiper
        height: 5.36rem;
        width: 100%;
        .swiper-slide
          display: flex;
          align-items: center;
          justify-content: center;
          a
            img
              width: 2.88rem;
              height: 4rem;
              display: block;
              box-shadow:0px 2px 19px 1px rgba(0, 0, 0, 0.1);
        .swiper-slide-prev,.swiper-slide-next
          z-index: 10
        .swiper-slide-active
          z-index: 11
          a
            img
              transform: scale(1.4);
              display: block;
        // .swiper-slide-visible:nth-of-type(1)
        //   a
        //     img
        //       opacity: .5;
      p
        color: #333;
        text-align: center;
      p:nth-child(2)
        margin-top: .3rem;
        font-size: .32rem;
        font-weight: bold;
      p:nth-child(3)
        font-size: .26rem;
        margin-top: .2rem;
        padding: 0 .76rem;
        line-height: .42rem;
        height: 3.78rem;
        ellipsisClamp2()
        -webkit-line-clamp: 9
    >div:nth-child(2)
      .custom-button
        margin: 0 auto;
        display: block;
  .slide5
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    padding-bottom: .6rem;
    >div:nth-child(1)
      >a
        display: block;
        position: relative;
        height: 3rem;
        img
          // width: 100%;
          height: 100%;
          position: absolute;
          top:50%;
          left: 0;
          transform:  translateY(-50%);
      >p
        color: #333;
        text-align: center;
      >p:nth-child(2)
        font-size: .32rem;
        font-weight: bold;
        margin-top: .48rem;
      >p:nth-child(3)
        font-size: .26rem;
        margin-top: .3rem;
        line-height: .42rem;
        padding: 0 .76rem;
      .grid
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: .32rem;
        padding: 0 .76rem;
        margin-top: .3rem;
        >div
          position: relative;
          >a:nth-child(1)
            width: 100%;
            height: 2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            overflow: hidden
            img
              max-width: 100%;
              max-height: 100%;
              display: block;
          >div:nth-child(2)
            position: absolute;
            bottom: 0;
            left: 0;
            padding: .2rem .1rem 0;
            background-repeat: no-repeat;
            background-image: url('~mpic/main5-1.png');
            width: 100%;
            height: .86rem;
            background-size: cover;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            line-height: .33rem;
            color: #fff;
    >div:nth-child(2)
      .custom-button
        margin: 0 auto;
        display: block;
  .slide6
    position: relative;
    background-image: url('~mpic/main6-2.png');
    background-size: cover;
    background-repeat: no-repeat;
    .content
      width: 6rem;
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transition: all .5s ease-in-out;
      transform: translateX(-50%) translateY(-50%);
      &.hide
        opacity: 0;
        p,img
          transform: translateX(-4rem);
      &.show
        opacity: 1;
        p,img
          transform: translateX(0);
      p
        color: #333333;
        text-align: center;
      p:nth-child(1)
        font-size: .42rem;
        font-weight: bold;
      p:nth-child(2)
        font-size: .26rem;
        margin: 1.1rem auto 0;
      img
        margin: 1.1rem auto 0;
        width: 2.75rem;
        height: 2.75rem;
        display: block;
    .footer
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      align-items: flex-end;
      div
        flex: 1;
        height: .88rem;
        background: rgba(255, 255, 255, 0.6);
        display: flex;
        justify-content: center;
        align-items: center;
        span
          color: #333333;
          font-size: .22rem;
        img
          margin-right: .12rem;
          width: .3rem;
          height: .3rem;
        &.active
          height: 1rem;
          background: #E12222;
          span
            color: #fff;
  .slide7
    position: relative;
    overflow: auto;
    display: flex;
    align-items: center
    justify-content: center
    flex-direction: column
    .slide7-tle
      font-size: .36rem
      text-align: center;
      color: #333
    .grid
      width: 100%;
      padding: .3rem .56rem;
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: .3rem;
      >div
        background: #E12222;
        width: 100%;
        height: 1.2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        img
          max-height: 1.2rem;
        // &:nth-child(1),&:nth-child(7),&:nth-child(9),&:nth-child(10)
        //   img
        //     width: 1rem;
        //     height: 1rem;
        // &:nth-child(2)
        //   img
        //     width: 1.23rem;
        //     height: 1rem;
        // &:nth-child(3)
        //   img
        //     width: 1.27rem;
        //     height: 1rem;
        // &:nth-child(4)
        //   img
        //     width: 1.08rem;
        //     height: 1rem;
        // &:nth-child(5)
        //   img
        //     width: 1.6rem;
        //     height: .78rem;
        // &:nth-child(6)
        //   img
        //     width: 1.07rem;
        //     height: 1.04rem;
        // &:nth-child(8)
        //   img
        //     width: 1.14rem;
        //     height: 1rem;
    .footer
      background: #F2F4F8;
      // position: absolute;
      // bottom: 0;
      // left: 0;
      width: 100%;
    // .footer
    //   background: #F2F4F8;
    //   width: 100%;
    //   position: absolute;
    //   bottom: 0;
    //   left: 0;
    //   padding: .4rem;
    //   p.title
    //     color: #333;
    //     font-weight: bold;
    //     font-size: .26rem;
    //   .partner
    //     color: #666;
    //     font-size: .22rem;
    //     display: flex;
    //     justify-content: space-between;
    //     p
    //       margin-top: .24rem;
    //       transform: scale(0.95);
    //     .left
    //       min-width: 2.62rem;
    //       width: 2.62rem;
    //       margin-right: .3rem;

  .custom-button
    width: 2rem;
    height: .6rem;
    background: #E12222;
    border-radius:.3rem;
    line-height: .6rem;
    padding: 0;
    color: #fff;
    border-width: 0;
  .main-swiper-pagination
    right: .36rem;
    >>>.swiper-pagination-bullet
      background: #CCCCCC;
      width: .12rem;
      height: .12rem;
      margin: .6rem auto;
      opacity: 1;
      &.swiper-pagination-bullet-active
        width: .24rem;
        height: .24rem;
        color: #E12222;
        border: .02rem solid #E12222;
        background: #fff;
        font-size: .24rem;
        outline: 0;
        position: relative;
        &::after
          position: absolute;
          top: 0;
          left: 0;
          width: .2rem;
          height: .2rem;
          display: flex;
          justify-content: center;
          align-items: center;
          transform: scale(.66);
      &:nth-child(1).swiper-pagination-bullet-active
        &::after
          content: '1'
      &:nth-child(2).swiper-pagination-bullet-active
        &::after
          content: '2'
      &:nth-child(3).swiper-pagination-bullet-active
        &::after
          content: '3'
      &:nth-child(4).swiper-pagination-bullet-active
        &::after
          content: '4'
      &:nth-child(5).swiper-pagination-bullet-active
        &::after
          content: '5'
      &:nth-child(6).swiper-pagination-bullet-active
        &::after
          content: '6'
      &:nth-child(7).swiper-pagination-bullet-active
        &::after
          content: '7'
</style>
